var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row justify-between q-col-gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            !_vm.isPublic
              ? _c("search-type-select", {
                  on: { updatedSearchType: _vm.setSearchType }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col col-shrink" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "text-overline" }, [
                _vm._v(_vm._s(_vm.$t("sorting")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("sorting-select", {
                  attrs: {
                    options: _vm.sortingOptions,
                    disable: _vm.switchingSearchTypes
                  },
                  on: {
                    updatedSortingDirection: _vm.changeSortingDirection,
                    updatedSorting: _vm.setSorting
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col col-shrink" },
          [
            _c("search-view-select", {
              on: { input: _vm.setSearchDisplayType }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.displayType === "teaser"
        ? [
            _c(
              "q-infinite-scroll",
              {
                attrs: {
                  offset: 6000,
                  debounce: 100,
                  disable: _vm.disableInfiniteScroll
                },
                on: { load: _vm.loadAdditionalResults },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "loading",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "row justify-center q-my-md" },
                            [
                              _c("q-spinner-dots", {
                                attrs: { color: "primary", size: "3em" }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2284664994
                )
              },
              [
                _c(
                  "div",
                  { staticClass: "row q-py-lg q-col-gutter-md" },
                  _vm._l(_vm.logSearchResults, function(object) {
                    return _c(
                      "div",
                      {
                        key: object.uid,
                        staticClass:
                          "col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                      },
                      [
                        _vm.isLogSearch
                          ? _c("veneer-log", {
                              attrs: {
                                log: object,
                                "watchlist-dialog": _vm.showWatchlistDialog,
                                "measurement-list-dialog": true,
                                "show-active-watchlist-check": true,
                                "is-dynamic-watchlist": _vm.isDynamicWatchlist,
                                "is-public": _vm.isPublic
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isPalletSearch
                          ? _c("pallet", { attrs: { pallet: object } })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAddToCurrentWatchlistButton
                          ? _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.addObjectToWatchlist(
                                      object,
                                      _vm.watchlist
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("button.addToWatchlist")))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _vm.displayInitialSearchSpinner
              ? _c("q-spinner-cube", {
                  staticClass: "absolute-center",
                  attrs: { color: "primary", size: "5em" }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.displayType === "table"
        ? [
            _c(
              "div",
              { staticClass: "row q-py-lg justify-center" },
              [
                _vm.isLogSearch
                  ? _c("veneer-log-table", {
                      on: {
                        "load-additional-results": _vm.loadAdditionalResults
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPalletSearch ? _c("pallet-table") : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.logSearchResults.length &&
      !_vm.loadingLogs &&
      _vm.displayType === "teaser"
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("q-icon", {
                attrs: { name: "clear", size: "5em", color: "primary" }
              }),
              _vm._v(" "),
              _vm.sufficientSearchParamsGiven
                ? _c("span", { staticClass: "text-h5 vertical-middle" }, [
                    _vm._v(_vm._s(_vm.$t("noResults")))
                  ])
                : _c("span", { staticClass: "text-h5 vertical-middle" }, [
                    _vm._v(_vm._s(_vm.$t("noSearchParams")))
                  ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }